import { Navigate } from 'react-router';
import { routes } from '../constants/routes';

const SetUpBusiness = () => {
  return <Navigate to={routes.onboarding} replace />;
};

export default SetUpBusiness;
